// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const sigilyph: PokeData = {
  "id": 561,
  "name": "sigilyph",
  "height": 14,
  "weight": 140,
  "base_experience": 172,
  "types": [
    PokeType.PSYCHIC,
    PokeType.FLYING
  ],
  "api_moves": [
    "gust",
    "whirlwind",
    "psybeam",
    "confusion",
    "psychic",
    "hypnosis",
    "light-screen",
    "reflect",
    "mirror-move",
    "sky-attack",
    "psywave",
    "skill-swap",
    "air-cutter",
    "cosmic-power",
    "gravity",
    "miracle-eye",
    "tailwind",
    "air-slash",
    "synchronoise"
  ],
  "moves": [
    "gust",
    "psychic",
    "reflect",
    "sky-attack",
    "psywave",
    "tailwind",
    "air-slash",
    "zen-headbutt",
    "calm-mind",
    "psychic-terrain",
    "roost",
    "healing-wish",
    "hurricane"
  ],
  "evolution_chain": {
    "id": 286,
    "item": null,
    "species": [
      {
        "name": "sigilyph",
        "order": 562,
        "types": [
          PokeType.PSYCHIC,
          PokeType.FLYING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 110,
    "speed": 141,
    "ability_power": 149
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
